export default __webpack_public_path__ + "static/media/gs8-var.1ba357ab.jpg";